import React from "react";
import RecordManager from "../../../components/founder/RecordManager";
import FilesPanel from "../../../components/founder/FilesPanel";
import { FactClassTag } from "../../../components/founder/ui";

const SOURCE_TYPES = ["Client intake", "Client interview", "Google review", "Google Business Profile", "Website", "Facebook", "Community recommendation", "Competitor website", "Competitor review", "Directory", "License record", "Screenshot", "Document", "Invoice", "Estimate", "Customer experience", "Mystery shop", "Founder observation", "Other"];
const FACT_CLASS = ["Observed Fact", "Client Report", "External Evidence", "Inference", "Hypothesis", "Unknown"];

export default function EvidenceTab({ ws, bid, reload }) {
  return (
    <div className="grid gap-5 lg:grid-cols-3">
      <div className="lg:col-span-2 lr-card p-5">
        <RecordManager
          resource="evidence" bid={bid} items={ws.evidence} testid="evidence-manager"
          title="Evidence Ledger" addLabel="Add evidence" onChange={reload}
          fields={[
            { name: "source_type", label: "Source type", type: "select", options: SOURCE_TYPES },
            { name: "source_url", label: "Source URL or file reference", type: "text" },
            { name: "observation", label: "Evidence text / observation", type: "textarea", rows: 3 },
            { name: "supports", label: "What it potentially supports", type: "textarea", rows: 2 },
            { name: "contradicts", label: "What it potentially contradicts", type: "textarea", rows: 2 },
            { name: "reliability", label: "Reliability", type: "select", options: ["High", "Medium", "Low"] },
            { name: "recency", label: "Recency", type: "select", options: ["Current", "Recent", "Older", "Unknown"] },
            { name: "fact_class", label: "Fact class", type: "select", options: FACT_CLASS },
            { name: "date_found", label: "Date found", type: "text" },
          ]}
          renderItem={(e) => (
            <div className="space-y-1.5">
              <div className="flex items-center gap-2 flex-wrap">
                <span className="text-sm font-medium text-lr-charcoal">{e.source_type}</span>
                {e.fact_class && <FactClassTag value={e.fact_class} />}
                {e.reliability && <span className="text-xs text-lr-leather">· {e.reliability} reliability</span>}
                {e.recency && <span className="text-xs text-lr-leather">· {e.recency}</span>}
              </div>
              {e.observation && <p className="text-sm text-lr-charcoal">{e.observation}</p>}
              {e.source_url && <a href={e.source_url} target="_blank" rel="noreferrer" className="text-xs text-lr-clay hover:underline break-all">{e.source_url}</a>}
              <div className="text-xs text-lr-leather">{e.supports && <span>Supports: {e.supports}. </span>}{e.contradicts && <span>Contradicts: {e.contradicts}.</span>}</div>
            </div>
          )}
        />
      </div>
      <div className="lr-card p-5"><FilesPanel bid={bid} files={ws.files} onChange={reload} /></div>
    </div>
  );
}
